import { Button } from "components/common/Button";
import { Input } from "components/common/Input";
import { useEffect } from "react";
import { useState } from "react";
import { ReactElement } from "react";

export function ModalRename(props: {
  initialParameterSetName: string;
  visible: boolean;
  setShowModal: React.Dispatch<React.SetStateAction<boolean>>;
  renameAction: (parameterSetName: string) => void;
}): ReactElement {
  const { initialParameterSetName, visible, setShowModal, renameAction } =
    props;
  const [parameterSetName, setParameterSetName] = useState<string>("");

  useEffect(() => {
    setParameterSetName(initialParameterSetName);
  }, [initialParameterSetName]);

  return (
    <div
      className={`fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 flex flex-col space-y-8 px-8 py-4 w-96 bg-white border-2 border-gray-300 shadow-2xl ${
        visible ? "visible" : "hidden"
      }`}
    >
      <div className="flex flex-row space-x-4 items-center">
        <div className="flex flex-col items-center justify-center w-12 h-12 rounded-full bg-blue-200">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth="1.5"
            stroke="currentColor"
            className="w-6 h-6 self-center text-blue-400"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M16.862 4.487l1.687-1.688a1.875 1.875 0 112.652 2.652L6.832 19.82a4.5 4.5 0 01-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 011.13-1.897L16.863 4.487zm0 0L19.5 7.125"
            />
          </svg>
        </div>
        <p className="font-bold">Umbenennen</p>
      </div>
      <Input
        placeholder=""
        type="text"
        value={parameterSetName}
        onChange={(e) => setParameterSetName(e.target.value)}
      />
      <div className="flex flex-row items-center justify-end space-x-4">
        <span
          className="cursor-pointer text-blue-400"
          onClick={() => {
            setShowModal(false);
          }}
        >
          Abbrechen
        </span>
        <Button
          className="bg-blue-400"
          onClick={() => {
            renameAction(parameterSetName);
            setShowModal(false);
          }}
        >
          Speichern
        </Button>
      </div>
    </div>
  );
}
